import { buildApiUrl } from "./apiConfig";

const ensureFetcher = (fetchWithAuth) => {
  if (typeof fetchWithAuth !== "function") {
    throw new Error("fetchWithAuth is required.");
  }
  return fetchWithAuth;
};

const parseResponse = async (response, fallback) => {
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload?.detail || fallback);
  }
  return payload;
};

export async function fetchListmonkStatus(fetchWithAuth) {
  const runner = ensureFetcher(fetchWithAuth);
  return parseResponse(
    await runner(buildApiUrl("/admin/listmonk/status")),
    "Listmonk-Status konnte nicht geladen werden."
  );
}

export async function synchronizeListmonk(fetchWithAuth) {
  const runner = ensureFetcher(fetchWithAuth);
  return parseResponse(
    await runner(buildApiUrl("/admin/listmonk/sync"), { method: "POST" }),
    "Listmonk-Synchronisierung fehlgeschlagen."
  );
}

export function getListmonkAdminUrl() {
  const configured = (process.env.REACT_APP_LISTMONK_ADMIN_URL || "").trim();
  if (configured) return configured.replace(/\/$/, "");
  if (typeof window === "undefined") return "https://listmonk.werbeauto.ch";
  const hostname = window.location.hostname;
  const segments = hostname.split(".").filter(Boolean);
  if (segments.length > 1) {
    return `${window.location.protocol}//listmonk.${segments.slice(1).join(".")}`;
  }
  return `${window.location.protocol}//listmonk.${hostname}`;
}
